(function () {
  'use strict';
  if ($(window).width() > 730) {
    let maxHeight = 0;
    $('.lpqvpay-data-card').each(function () {
      if ($(this).outerHeight() > maxHeight) {
        maxHeight = $(this).outerHeight();
      }
    });
    $('.lpqvpay-data-card').css('height', maxHeight + 'px');
  }
})();

(function () {
  'use strict';
  // Abre popup para envio de documento (Desktop)
  if ($(window).width() > 730) {
    $('.btn-send-doc').on('click', function (ev) {
      ev.preventDefault();
      const url = $(this).attr('href');
      if (url) {
        const width = 600;
        const height = 400;
        const left = screen.width / 2 - width / 2;
        const top = screen.height / 2 - height / 2;
        window.open(
          url,
          'popupWindow',
          'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',scrollbars=yes',
        );
      }
    });
  }
})();
